import { fullName } from 'utils/full-name';
import { sortByText } from 'utils/sort-by-text';
import { SchedulerResourceType } from '../resource-types';
import { projectNameSorter } from '../utils/resource-tree';

export const getUsersSorter = () => ({
  fn: (recordA, recordB) => {
    const typeA = recordA.get('type');
    const typeB = recordB.get('type');

    if (typeA === SchedulerResourceType.TeamHeader) {
      return -1;
    }
    if (typeB === SchedulerResourceType.TeamHeader) {
      return 1;
    }
    if (
      typeA === SchedulerResourceType.Company &&
      typeB === SchedulerResourceType.Company
    ) {
      return sortByText(recordA.get('companyName'), recordB.get('companyName'));
    }
    if (
      typeA === SchedulerResourceType.ExpandableRole &&
      typeB === SchedulerResourceType.ExpandableRole
    ) {
      return sortByText(recordA.get('roleName'), recordB.get('roleName'));
    }
    if (
      typeA === SchedulerResourceType.Team &&
      typeB === SchedulerResourceType.Team
    ) {
      const projectSort = sortByText(
        recordA.get('projectName'),
        recordB.get('projectName'),
      );

      return projectSort === 0
        ? sortByText(recordA.get('teamName'), recordB.get('teamName'))
        : projectSort;
    }
    if (
      typeA === SchedulerResourceType.User &&
      typeB === SchedulerResourceType.User
    ) {
      const nameA = fullName({
        firstName: recordA.get('firstName'),
        lastName: recordA.get('lastName'),
      });

      const nameB = fullName({
        firstName: recordB.get('firstName'),
        lastName: recordB.get('lastName'),
      });

      return sortByText(nameA, nameB);
    }
    if (
      typeA === SchedulerResourceType.Project &&
      typeB === SchedulerResourceType.Project
    ) {
      const projectNameSort = projectNameSorter(
        {
          projectName: recordA.get('projectName'),
        },
        {
          projectName: recordB.get('projectName'),
        },
      );

      const referenceTeamA = recordA.get('referenceTeam');
      const referenceTeamB = recordB.get('referenceTeam');

      if (projectNameSort === 0) {
        if (referenceTeamA) {
          if (referenceTeamB) {
            return sortByText(referenceTeamA.teamName, referenceTeamB.teamName);
          }
        }

        return referenceTeamA ? 1 : referenceTeamB ? -1 : projectNameSort;
      }

      return projectNameSort;
    }
    if (typeA === SchedulerResourceType.AssignProject) {
      return 1;
    }
    if (typeB === SchedulerResourceType.AssignProject) {
      return -1;
    }

    return 0;
  },
});
